import { useSearchParams } from 'react-router-dom';
import { LinksList } from '@/components/links';
import { useSortPreference } from '@/hooks/useSortPreference';

type FilterType = 'unread' | 'favorites' | 'archived' | undefined;

export function Dashboard() {
  const [searchParams] = useSearchParams();
  const filter = searchParams.get('filter') as FilterType;
  const { sortPreference } = useSortPreference();

  return (
    <div className="py-6">
      <LinksList
        filter={filter || undefined}
        sortBy={sortPreference.field}
        sortOrder={sortPreference.order}
      />
    </div>
  );
}
